<template>
    <form @submit.prevent="changeUsername()">
        <div class="form-group form-sm-right">
            <div class="input-group" v-if="validationErrors.length">
                <p v-for="validationError in validationErrors" :key="validationError.index"><label class="text-danger" v-text="validationError" /></p>
            </div>
        </div>

        <div class="form-sm-left">
            <div class="form-group">
                <div class="input-group">
                    <label for="currentUsername"><b>{{ $t("message.currentUsername") }} *</b></label>
                    <input id="currentUsername" name="username" type="text" v-model="changeUsernameData.CurrentUsername" class="form-control" :disabled="isCSR || currentUsernameFromStore.length > 0" ref="profileCurrentUsername" />
                </div>
            </div>

            <div class="form-group">
                <div class="input-group">
                    <label for="newUsername">
                        <b>{{ $t("message.newUsername") }} *</b>&nbsp;
                        <span v-if="this.$store.getters.getEmailAsUsername" class="font-sm">{{ ($t("message.emailAsUsername")) }}</span>
                    </label>
                    <input id="newUsername" name="newUsername" type="text" v-model="changeUsernameData.NewUsername" class="form-control" ref="profileNewUsername" :disabled="isCSR" />
                    
                </div>
            </div>

            <div class="form-group">
                <div class="input-group">
                    <label for="confirmNewUsername"><b>{{ $t("message.confirmNewUsername") }} *</b></label>
                    <input id="confirmNewUsername" name="confirmNewUsername" type="text" v-model="changeUsernameData.ConfirmNewUsername" class="form-control" :disabled="isCSR" />
                </div>
            </div>

            <div class="form-group">
                <div class="input-group">
                    <label for="confirmPassword"><b>{{ $t("message.currentPassword") }} *</b></label>
                    <input id="confirmPassword" name="confirmPassword" type="password" v-model="changeUsernameData.CurrentPassword" class="form-control" :disabled="isCSR" />
                </div>
            </div>

            <div class="form-group">
                <p>
                    <button id="btnChangeUsername" type="submit" class="btn btn-sm btn-primary" 
                                @click.prevent="changeUsername()" :disabled="inputNotValid" aria-label="Submit">{{ $t("message.submit") }}</button>
                    <button id="btnCancelUsername" type="submit" class="btn btn-sm btn-primary" @click.prevent="cancel()" aria-label="Cancel">{{ $t("message.cancel") }}</button>
                </p>
            </div>
        </div>        
    </form>
</template>

<script>
import axios from "axios";

export default {
    name: 'ChangeUsername',
    data() {
        return {
            changeUsernameData: {
                CurrentUsername: this.$store.getters.getCustomerUsername,
                NewUsername: '',
                ConfirmNewUsername: '',
                CurrentPassword: '',
                ResponseType: '',
                Message: ''
            },
            currentUsernameFromStore: this.$store.getters.getCustomerUsername,
            validationErrors: []
        }
    },
    mounted() {        
        this.$nextTick(() => {
            if (this.currentUsernameFromStore.length > 0) {
                this.$refs.profileNewUsername.focus();
            } else {
                this.$refs.profileCurrentUsername.focus();
            }            
        });        
    },
    methods: {
        changeUsername() {
            axios({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "Profile/ChangeUsername",
                data: {
                    changeUsernameData: this.changeUsernameData
                }
            }).then(result => {
                var response = result.data;
                if (response !== '') {
                    var responseType = response.ResponseType;
                    var messageToDisplay = response.Message;

                    if (responseType === this.$ResponseType.Error) {
                        this.showMessage(messageToDisplay, responseType);
                    } else {
                        this.showMessage(messageToDisplay, responseType);
                        this.updateNewUsernameInStore(response.NewUsername);
                        
                        this.changeUsernameData = [];

                        this.$router.push({ name: "Home" });
                    }
                } else {
                    this.showMessage("An error has occurred. Username has not been saved, please try again.", this.$ResponseType.Error);
                }
            }, error => {
                console.log(error);
            })
        },
        updateNewUsernameInStore(newUsername) {
            this.$store.commit('setUsername', newUsername);
            
            var usernameFromStore = this.$store.getters.getCustomerUsername;
            this.currentUsernameFromStore = usernameFromStore;
            this.changeUsernameData.CurrentUsername = usernameFromStore;
        },
        cancel() {
            this.$router.push({ name: "Home" });
        },
        showMessage(message, type) {
            this.$toasted.show(message, {type: type, position: 'top-center', duration: '2000'});
            this.$announcer.set(message);
        }
    },
    computed: {     
        // No need to validate input if CSR is viewing this component as CSR's are not allowed to update username  
        inputNotValid() {
            if (!this.$store.getters.getIsCSR) {
                this.validationErrors = [];
                var fieldsEmpty = false;
                var usernamesDontMatch = false;
                var usernameNotEmail = false;

                if (this.changeUsernameData.CurrentUsername.length === 0 || this.changeUsernameData.NewUsername.length === 0 
                            || this.changeUsernameData.ConfirmNewUsername.length === 0 || this.changeUsernameData.CurrentPassword.length === 0) {
                    this.validationErrors.push("Current Username, New Username, Confirm New Username and Confirm Password are required fields");
                    fieldsEmpty = true;
                }

                if (this.$store.getters.getEmailAsUsername) {
                    // Validate if new username input is Email
                    if (!this.$checkEmail(this.changeUsernameData.NewUsername)) {
                        this.validationErrors.push("An email address is required as your username.");
                        usernameNotEmail = true;
                    }
                } else {
                    usernameNotEmail = false;
                }

                if (this.changeUsernameData.NewUsername !== this.changeUsernameData.ConfirmNewUsername) {
                    this.validationErrors.push("Usernames don't match");
                    usernamesDontMatch = true;
                }            

                return fieldsEmpty || usernamesDontMatch || usernameNotEmail;
            } else {
                return true;
            }            
        },
        isCSR() {
            return this.$store.getters.getIsCSR;
        }
    }
}
</script>